import { createActions } from 'redux-actions';

export type RequestDocumentsPayload = {
  claimableType: string;
  claimableId: number;
  documentTypes: string[];
  note?: string;
};

export const { requestDocuments, requestDocumentsSuccess, requestDocumentsReset } = createActions(
  'REQUEST_DOCUMENTS',
  'REQUEST_DOCUMENTS_SUCCESS',
  'REQUEST_DOCUMENTS_RESET',
  {
    prefix: 'USER_DASHBOARD_REQUEST_DOCUMENTS_MODAL',
  },
);
